import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { applySystemBrand, loadSystemSettings } from './lib/system-settings'
import { installClientStorageSync } from './lib/client-storage-sync'

const domGuardKey = "__seoAgentDomMutationGuard__";

function installDomMutationGuard() {
  const proto = Node.prototype as Node & {
    [domGuardKey]?: boolean;
    insertBefore: typeof Node.prototype.insertBefore;
    removeChild: typeof Node.prototype.removeChild;
  };

  if (proto[domGuardKey]) return;
  proto[domGuardKey] = true;

  const nativeInsertBefore = proto.insertBefore;
  const nativeRemoveChild = proto.removeChild;

  proto.insertBefore = function insertBeforeGuard<T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return this.appendChild(newNode) as T;
    }
    return nativeInsertBefore.call(this, newNode, referenceNode) as T;
  };

  proto.removeChild = function removeChildGuard<T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return nativeRemoveChild.call(this, child) as T;
  };
}

installDomMutationGuard();
installClientStorageSync();
applySystemBrand(loadSystemSettings());

const rootEl = document.getElementById("root")!;
rootEl.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:Arial,sans-serif;color:#335247;background:#f6faf7">良木AI loading...</div>';

try {
  rootEl.replaceChildren();
  createRoot(rootEl).render(<App />);
} catch (error) {
  console.error("App bootstrap failed", error);
  rootEl.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:Arial,sans-serif;color:#b91c1c;background:#fff7ed">App bootstrap failed. Please refresh.</div>';
}
